module.exports = __webpack_public_path__ + "img/header-background.4f487bfa.png";